import { render, staticRenderFns } from "./mcfenxi.vue?vue&type=template&id=0b613cbc&scoped=true"
import script from "./mcfenxi.vue?vue&type=script&lang=js"
export * from "./mcfenxi.vue?vue&type=script&lang=js"
import style0 from "./mcfenxi.vue?vue&type=style&index=0&id=0b613cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b613cbc",
  null
  
)

export default component.exports